import React, { useState } from 'react';

import InfoIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';

import Slider from '../../../../../shared/Slider';
import AlertModal from '../../../../AlertModal';

export const DfoSagittal = (props) => {
  const {
    PTS,
    initialPTS,
    handlePTSChange,
    skipModalOpen,
    activeCase,
    toggleSkipModal,
    handleSubmit,
  } = props;

  const theme = useTheme();

  const classes = {
    tooltip: {
      padding: theme.spacing(2),
      fontSize: '1rem',
      whiteSpace: 'pre-line !important',
    },
    active: {
      '& > div': {
        padding: '2px 8px !important',
        border: `2px solid ${theme.palette.primary.main}`,
        borderRadius: 20,
        '& .alignment-data-value': {
          color: theme.palette.primary.main,
          fontWeight: 700,
        },
      },
    },
  };

  const { procedureSide } = activeCase;

  const [activeValue, setActiveValue] = useState('PTS');

  const min = initialPTS - 10;
  const max = initialPTS + 10;

  const tooltip =
    'Select desired sagittal correction angle by adjusting slider.\n' +
    '\n' +
    'By default, the tibial slope remains unchanged.\n' +
    '\n' +
    'Image is an animated representation of the resultant deformity correction only and should not be referenced for any clinical decision making';

  const getImageSrc = () => {
    const url = `/sagittal_bone_images/DFO_${procedureSide}`;

    if (PTS < min) {
      return `${url}/${min}_bone.png`;
    } else if (PTS > max) {
      return `${url}/${max}_bone.png`;
    } else if (PTS === initialPTS) {
      return `${url}/0_bone.png`;
    } else {
      return `${url}/${Math.floor(PTS - initialPTS)}_bone.png`;
    }
  };

  return (
    <>
      <div className="modal-item-block flex-1 step-4-container margin-0">
        <div className="values-list">
          <div className="flex-1 m-r-md">
            <div className="block-header">Preoperative</div>
            <div className="alignment-data-item">
              <div>
                <div>PDFA (°)</div>
                <div>{initialPTS}</div>
              </div>
            </div>
            <div className="m-t-md">
              <Tooltip
                title={tooltip}
                placement="right"
                enterTouchDelay={50}
                classes={{ tooltip: classes.tooltip }}
                leaveTouchDelay={3000}
              >
                <InfoIcon color="primary" height={20} />
              </Tooltip>
            </div>
          </div>
          <div className="flex-1 m-l-md">
            <div className="block-header">Postoperative</div>
            <div
              className={`alignment-data-item pointer ${
                activeValue === 'PTS' ? classes.active : ''
              }`}
              onClick={() => setActiveValue('PTS')}
            >
              <div>
                <div>
                  PDFA <span className="secondary">(°)</span>
                </div>
                <div className="alignment-data-value">{PTS}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="image-container sagittal">
          <figure>
            <img src={getImageSrc()} alt="sagittal-bone" />
            <figcaption className="text-center">Posterior Distal Femoral Angle (°)</figcaption>
          </figure>
        </div>
        <Slider
          value={PTS}
          onChange={handlePTSChange}
          defaultValue={PTS}
          min={min}
          max={max}
          step={0.5}
          decimal
          inverted={procedureSide === 'left'}
        />

        <div className="font-size-sm secondary text-center m-t-sm">Sagittal view</div>
      </div>

      <AlertModal
        open={skipModalOpen}
        onClose={() => toggleSkipModal(false)}
        onSubmit={() => {
          toggleSkipModal(false);
          handleSubmit();
        }}
        title="Do you need to adjust Posterior Distal Femoral Angle?"
        text="To avoid delays in the processing of this case only make adjustments if necessary, otherwise continue to the summary screen"
        submitText="Continue"
        closeText="Adjust"
      />
    </>
  );
};
